import { Notify } from "vant";
import Storage from "./storage";

class ClientRequest {

    request(url, options = {}) {
        const abortController = new AbortController()
        const promise = new Promise(async (r, j) => {
            let apiUrl = `${process.env.API_URL}${url}`;
            let info = new URL(apiUrl);
            let headers = {};

            if (options.params) {
                Object.keys(options.params).map((key) => {
                    info.searchParams.set(key, options.params[key]);
                });
            }

            let token = Storage.get("token");
            if (token) {
                headers.Authorization = `Bearer ${token}`;
            }

            let response
            try {
                response = await fetch(`${info.toString()}`, {
                    method: options.method,
                    body: options.body,
                    headers: headers,
                    signal: abortController.signal
                });
            } catch (error) {
                let message = error.message
                if (message == 'Failed to fetch') {
                    error = new Error('服务器中断或网络不畅')
                }
                return j(error)
            }

            if (response.status == 200) {
                r(await response.json());
            } else {
                let data = {};
                try {
                    data = await response.json();
                } catch (error) { }
                let msg =
                    typeof data.data !== "undefined" && data.data !== ""
                        ? data.data
                        : "请求出错了";
                if (options.noMessage !== true) {
                    Notify({ type: "danger", message: msg });
                }
                j(new Error(msg));
            }
        });
        promise.abort = () => abortController.abort()
        return promise
    }

    get(url, query = {}, options = {}) {
        return this.request(url, {
            ...options,
            params: query,
            method: "GET",
        });
    }

    post(url, body, options = {}) {
        return this.request(url, {
            ...options,
            body,
            method: "POST",
        });
    }

    form(url, body = {}, options = {}) {
        let form = new FormData();
        Object.keys(body).map((key) => {
            form.append(key, body[key]);
        });
        return this.request(url, {
            ...options,
            body: form,
            method: "POST",
        });
    }
}

export default new ClientRequest();
